export default {
    APOLLO_STATE_PROP_NAME: '__APOLLO_STATE__'
}